import { useMemo } from 'react';
import Fuse from 'fuse.js';
import { throwNetworkError } from '@twnel/web-components';

import { visualBuilderActions } from './reducer';

const { toggleElementInfo, uploadingFileToS3 } = visualBuilderActions;

export const { resetVisualbuilder } = visualBuilderActions;

export const openPanel = (content) => toggleElementInfo({ showNodePanel: true, content });

// El contenido se limpia después de la animación de cierre del panel.
export const closePanel = () => (dispatch) => {
  dispatch(toggleElementInfo({ showNodePanel: false }));
  setTimeout(() => dispatch(toggleElementInfo({ content: null })), 250);
};

export const toggleUploadinFile = (uploading) => uploadingFileToS3({ uploading });

export const useFuzzySearch = (items, searchKeys, callback) => useMemo(() => {
  const fuse = new Fuse(items, {
    includeScore: true,
    threshold: 0.2,
    keys: searchKeys,
  });
  return (query) => {
    if (!query) {
      callback(null);
      return items.map((item) => ({ item }));
    }

    const searchResults = fuse.search(query);
    if (searchResults.length >= 1 && searchResults[0].score < 0.001) {
      callback(searchResults[0].item);
    } else {
      callback(null);
    }
    return searchResults;
  };
}, [items, searchKeys, callback]);

export const uploadFile = ({ file, savingMedia }) => (
  dispatch, _getState, getContext,
) => {
  const { api } = getContext();
  dispatch(toggleUploadinFile(true));
  return api.companies.uploadFile(file)
    .then(({ url }) => {
      dispatch(toggleUploadinFile(false));
      if (savingMedia) savingMedia(url);
    })
    .catch((error) => throwNetworkError(error));
};
